// src/pages/NotFound.jsx

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Home,
  Mail,
  MessageCircle,
  SearchX,
} from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  const whatsappNumber = "2348069804062";

  const openWhatsappSupport = () => {
    const text = encodeURIComponent(
      "Hello Zaviramed, I visited a page that could not be found. Please assist me."
    );

    window.open(
      `https://wa.me/${whatsappNumber}?text=${text}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const openEmailSupport = () => {
    const subject = encodeURIComponent("Page Not Found Support");
    const body = encodeURIComponent(
      "Hello Zaviramed,\n\nI visited a page that could not be found. Please assist me."
    );

    window.location.href = `mailto:support@zaviramed.com.ng?subject=${subject}&body=${body}`;
  };

  return (
    <main className="min-h-screen bg-[#FAFBF8] text-slate-950">
      <header className="mx-auto flex w-full max-w-7xl items-center justify-between px-5 py-5 sm:px-8">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/logo_new_nobg.png"
            alt="Zaviramed"
            className="h-9 w-auto object-contain"
          />
          <span className="text-sm font-semibold tracking-tight text-slate-900">
            Zaviramed
          </span>
        </Link>

        <button
          type="button"
          onClick={() => {
                      window.location.href = "mailto:support@zaviramed.com.ng";
                    }}
          className="hidden rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-emerald-300 hover:text-emerald-700 sm:inline-flex"
        >
          Need help?
        </button>
      </header>

      <section className="mx-auto grid min-h-[calc(100vh-88px)] w-full max-w-7xl items-center px-5 pb-16 pt-8 sm:px-8 lg:grid-cols-[0.95fr_1.05fr] lg:gap-14">
        <div className="max-w-2xl">
          <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-600">
            <SearchX size={14} />
            404 · Page not found
          </div>

          <h1 className="text-[4.8rem] font-black leading-none tracking-[-0.08em] text-slate-950 sm:text-[7rem] lg:text-[8.5rem]">
            404
          </h1>

          <h2 className="mt-4 max-w-xl text-3xl font-semibold tracking-[-0.04em] text-slate-950 sm:text-5xl">
            This page has moved, expired, or does not exist.
          </h2>

          <p className="mt-5 max-w-xl text-base leading-8 text-slate-600">
            The link may be incorrect, old, or unavailable. If this was a
            consultation, payment, call, prescription, referral, or review link,
            Zaviramed support can help you recover the correct one.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-slate-950 px-5 py-3.5 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              <Home size={18} />
              Go home
            </Link>

            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-3.5 text-sm font-semibold text-slate-900 transition hover:bg-slate-50"
            >
              <ArrowLeft size={18} />
              Go back
            </button>
          </div>

          <div className="mt-10 flex flex-col gap-3 border-t border-slate-200 pt-6 sm:flex-row">
          

            <button
              type="button"
              onClick={openEmailSupport}
              className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 transition hover:text-slate-950"
            >
              <Mail size={18} />
              Email support
            </button>
          </div>
        </div>

        <div className="mt-14 hidden lg:block">
          <div className="relative mx-auto aspect-square max-w-[520px] rounded-[3rem] border border-slate-200 bg-white p-10">
            <div className="absolute left-10 top-10 h-16 w-16 rounded-3xl bg-emerald-50" />
            <div className="absolute bottom-10 right-10 h-24 w-24 rounded-full bg-slate-100" />
            <div className="absolute right-16 top-20 h-2 w-24 rounded-full bg-emerald-300" />
            <div className="absolute bottom-28 left-16 h-2 w-32 rounded-full bg-slate-300" />

            <div className="flex h-full flex-col items-center justify-center text-center">
              <div className="flex h-28 w-28 items-center justify-center rounded-[2rem] border border-slate-200 bg-[#FAFBF8] text-slate-900">
                <SearchX size={48} />
              </div>

              <p className="mt-8 max-w-xs text-sm font-medium leading-7 text-slate-500">
                We could not locate the page or link you requested.
              </p>

              <div className="mt-8 grid w-full max-w-xs gap-3">
                <div className="h-3 rounded-full bg-slate-100" />
                <div className="h-3 rounded-full bg-slate-100" />
                <div className="h-3 w-2/3 rounded-full bg-slate-100" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default NotFound;